import { useStableLiveFormEditorContext } from "@/features/LiveFormEditor/common/LiveFormEditorContext";

export interface CampaignSalesDates {
  hasCustomSalesOpenDate: boolean;
  hasCustomSalesCloseDate: boolean;
}

interface CampaignSalesDatesSource {
  salesOpenDate?: Date | string | null;
  salesClosedDate?: Date | string | null;
  recurrences?:
    | { openDate?: Date | string | null; closeDate?: Date | string | null; isHidden?: boolean | null }[]
    | null;
}

export const getCampaignSalesDates = (ticketing: CampaignSalesDatesSource): CampaignSalesDates => {
  const sellableRecurrences = (ticketing.recurrences ?? []).filter((recurrence) => !recurrence.isHidden);

  return {
    hasCustomSalesOpenDate:
      Boolean(ticketing.salesOpenDate) || sellableRecurrences.some((recurrence) => Boolean(recurrence.openDate)),
    hasCustomSalesCloseDate:
      Boolean(ticketing.salesClosedDate) || sellableRecurrences.some((recurrence) => Boolean(recurrence.closeDate)),
  };
};

export const useCampaignSalesDates = (): CampaignSalesDates => {
  const { apiFormObject: apiTicketing } = useStableLiveFormEditorContext<"ticketing">();

  return getCampaignSalesDates(apiTicketing);
};
